import React, { Component } from "react";
import {connect} from "react-redux";
import Cookies from "js-cookie";
import {PropagateLoader} from "react-spinners";
import {FormattedMessage} from "react-intl";

// @mui/material components
import {withStyles} from "@mui/styles";

// core components
import {fetch} from "../dataAccess";
import {sessionStore} from "../sessionStore";

import { putSessionOrganizations } from "../../actions/authentication";

// styles
import {primaryColor} from "../../assets/jss/main";
import loginStyle from "assets/jss/views/loginStyle";

import {putMemberRetailersInShittyCookie} from "../../actions/authentificationMember";
import {clearRequestedLocation, getRequestedLocation} from "../requestedLocation";
import {Link} from "react-router-dom";

export function successToken(token) {
    return {type: "LOGIN_SUCCESS_TOKEN", token};
}

export function successApplications(applications) {
    return {type: "LOGIN_SUCCESS_APPLICATIONS", applications};
}

export function successAuthorizations(authorizations) {
    return {type: "LOGIN_SUCCESS_AUTHORIZATIONS", authorizations};
}

export function successMember(member) {
    return {type: "LOGIN_SUCCESS_MEMBER", member};
}

export function successOrganizations(organizations) {
    return {type: "LOGIN_SUCCESS_ORGANIZATIONS", organizations};
}

export function successInvitations(invitations) {
    return {type: "LOGIN_SUCCESS_INVITATIONS", invitations};
}
class Callback extends Component {
    async componentDidMount() {
        const token = window.location.hash.split("&")[0].replace("#access_token=", "");
        const authSubdomain = process.env.REACT_APP_CUSTOM_AUTH_SUBDOMAIN ?? "auth.";

        await fetch("/login_sync", {method: "GET", headers: new Headers({"authorization": "Bearer " + token})})
            .then(response => {
                return response.json();
            })
            .then(data => {
                const dataString = JSON.stringify(data["syncedData"]);

                if (!data["syncedData"]["organizations"]) {
                    Cookies.set("_s", dataString, {domain: process.env.REACT_APP_HOST, expires: 0.02, secure: true});

                    let url = authSubdomain + process.env.REACT_APP_HOST;
                    let protocol = window.location.protocol;
                    let host = window.location.host;
                    let parts = host.split(":");

                    if (parts[0] === url) {
                        // in-case we have a port number in the host url. (For dev environment)
                        if (parts.length === 2) {
                            url += ":" + parts[1]
                        }

                        if (!data["syncedData"]["givenName"] && !data["syncedData"]["familyName"]) {
                            window.location = protocol + "//" + url + "/completeprofile";
                        } else if (data["syncedData"]["invitations"]) {
                            window.location = protocol + "//" + url + "/invitation";
                        } else {
                            window.location = protocol + "//" + url + "/signin";
                        }
                    }
                } else {
                    sessionStore.set('applications', data["syncedData"]["applications"]);
                    sessionStore.set('authorizations', data["syncedData"]["authorizations"]);
                    const member = data.syncedData?.member;
                    putMemberRetailersInShittyCookie(member?.retailers);
                    if (!!member) {
                        delete member['retailers'];
                        sessionStore.set('member', member);
                    }
                    putSessionOrganizations(data["syncedData"]["organizations"]);
                    sessionStore.set('invitations', data["syncedData"]["invitations"]);
                    Cookies.set( "_f", JSON.stringify(data["syncedData"]["token"]), {domain: process.env.REACT_APP_HOST, expires: 0.4, secure: true});
                    sessionStore.set('token', data["syncedData"]["token"]);

                    this.props.successApplications(data["syncedData"]["applications"]);
                    this.props.successAuthorizations(data["syncedData"]["authorizations"]);
                    this.props.successMember(data["syncedData"]["member"]);
                    this.props.successOrganizations(data["syncedData"]["organizations"]);
                    this.props.successInvitations(data["syncedData"]["invitations"] ? data["syncedData"]["invitations"] : null);
                    this.props.successToken(data["syncedData"]["token"]);

                    // Redirect to the org subdomain
                    const orgId = member ? member.organization : null;
                    const org = orgId ? data["syncedData"]["organizations"][orgId] : null;
                    if (org && org.subdomain) {
                        let redirectUrl = window.location.protocol + "//" + org.subdomain + "." + process.env.REACT_APP_HOST;
                        const hostParts = window.location.host.split(":");
                        if (hostParts.length === 2) {
                            redirectUrl += ":" + hostParts[1];
                        }

                        const requestedLocation = getRequestedLocation();
                        if (requestedLocation && requestedLocation.subdomain === org.subdomain) {
                            clearRequestedLocation();
                            redirectUrl += requestedLocation.path;
                        }

                        window.location = redirectUrl;
                    }
                }
            }).catch(error => {
                let url = authSubdomain + process.env.REACT_APP_HOST;
                let protocol = window.location.protocol;
                let host = window.location.host;
                let parts = host.split(":");

                if (parts[0] === url) {
                    // in-case we have a port number in the host url. (For dev environment)
                    if (parts.length === 2) {
                        url += ":" + parts[1]
                    }
                }
                window.location = protocol + "//" + url + "/validateaccount";
            });
    }

    render() {
        return (
            <div className={this.props.classes.container}>
                <FormattedMessage id={"login.loading"}/>
                <PropagateLoader sizeUnit={"px"} size={16} color={primaryColor} loading={true}/>
                <Link className={this.props.classes.logoutButton} to={`/logout`}>
                    <FormattedMessage id={"login.logout"}/>
                </Link>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        successToken: (token) => dispatch(successToken(token)),
        successApplications: (applications) => dispatch(successApplications(applications)),
        successAuthorizations: (authorizations) => dispatch(successAuthorizations(authorizations)),
        successMember: (member) => dispatch(successMember(member)),
        successOrganizations: (organizations) => dispatch(successOrganizations(organizations)),
        successInvitations: (invitations) => dispatch(successInvitations(invitations)),
    };
};

export default connect(null, mapDispatchToProps)(withStyles(loginStyle)(Callback));
